import * as React from 'react'
import './Steps.css'
import * as _ from 'lodash'

// import Tooltip from 'rc-tooltip';
// import 'rc-tooltip/assets/bootstrap_white.css';
import './tooltip.css'

import Step from "./Step"
// import * as actions from "../actions"

import classNames from 'classnames';

import { NetworkUser } from 'golgi'
import * as Model from '../types/document'
import { Cursor, CursorV } from '../lib/Cursor';
import { Stack } from 'src/types/stack';

import StepSpacer from 'src/view/StepSpacer';


class Steps extends React.Component<{
  blockC: Cursor<Model.Block>,
  stepsC?: Cursor<Model.Steps>
  stack: Stack
}> {

  render() {
    // console.log("STEPS OUTER RENDER")
    return <NetworkUser debugName="Steps" props={this.props} state={this.state} render={() => {
      // console.log("STEPS INNER RENDER")
      const {blockC, stack} = this.props
      const {stepsC = blockC.select('steps')} = this.props

      const stepCs = CursorV.elemsKeyed(stepsC.fetch(), 'id')

      const hasSpacers = true
      return <div className={classNames("Steps", {"Steps-with-spacers": hasSpacers, "Steps-empty": stepsC.get().length === 0})}>
        {stepCs.map((stepC, i) =>
          <React.Fragment key={stepC.lastStep().id}>
            { hasSpacers
              && <StepSpacer index={i} blockC={blockC} stepsC={stepsC} stack={stack} />}
            <Step stepC={stepC.unfetch()} stepsC={stepsC} blockC={blockC} stack={stack}/>
          </React.Fragment>
        )}
        {hasSpacers && <StepSpacer index={stepsC.get().length} blockC={blockC} stepsC={stepsC} stack={stack} alwaysShow={stepsC.get().length === 0} />}
      </div>
    }} />
  }
}

export default Steps;



// WEBPACK FOOTER //
// ./src/view/Steps.tsx